import { render, staticRenderFns } from "./WysiwygField.vue?vue&type=template&id=245f6bb3&scoped=true&"
import script from "./WysiwygField.vue?vue&type=script&lang=js&"
export * from "./WysiwygField.vue?vue&type=script&lang=js&"
import style0 from "./WysiwygField.vue?vue&type=style&index=0&id=245f6bb3&lang=scss&scoped=true&"
import style1 from "./WysiwygField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f6bb3",
  null
  
)

export default component.exports